import { useCompetitionGroupListQuery } from '../queries';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { useParams } from '~/hooks/useParams';
import { idParamSchema } from '~/schemas';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'>;

function GroupSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { id } = useParams(idParamSchema.parse);
  const { data, isLoading } = useCompetitionGroupListQuery({ competition: id });

  return (
    <Input.Select
      options={data?.results.map(d => [d.name ?? '', d.id]) ?? []}
      placeholder={props.placeholder ?? 'Alla grupper'}
      disabled={isLoading || props.disabled}
      ref={ref}
      {...props}
    />
  );
}

export const GroupSelect = forwardRef(GroupSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof GroupSelectElement>;
